export const BASENAME = process.env.MIX_APP_BASENAME;

export const APP_NAME = process.env.MIX_APP_NAME;

export const TITLE_TEMPLATE = "%s | "+APP_NAME;

export const PREFIX_NAME_APP = '';
export const PREFIX_NAME_MANAGER_ROUTING = 'intranet.';

export const WHATPSAPP = {
	number: '51989143630',
}
